import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Image, Row } from "react-bootstrap";
import {
  DeleteIcon,
  ListCheckIcon,
  ListPlusIcon,
  OverflowMenuIcon,
  PreviewIcon,
  UploadCloudIcon
} from "../data/iconImage";
import ButtonLink from "./ButtonLink";
import { useNavigate } from "react-router-dom";

const ButtonOptionGroup = ({
  data,
  rowIndex,
  defaultData,
  linkBtn,
  activeButton,
  onUploadCallback,
  onAddRowCallback,
  onCopiedRowCallback,
  onDeleteRowCallback,
  navView
}) => {
  
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [newData, setNewData] = useState([]);

  const handleUploadFile = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const arrayBuffer = reader.result;
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });
        onUploadCallback({ file, blob });
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleAddRow = (index) => {
    const addedRow = newData.find((row, idx) => idx === index);
    if (addedRow) {
      const rowData = [...newData, { ...defaultData }];
      setNewData(rowData);
      onAddRowCallback(rowData);
    }
  };

  const handleCopyRow = (index) => {
    const copiedRow = newData.find(({ Id, ...row }, idx) => idx === index);
    if (copiedRow) {
      const rowData = [...newData, { ...copiedRow }];
      setNewData(rowData);
      onCopiedRowCallback(rowData, index);
    }
  };

  const handleDeleteRow = (index) => {
    setNewData(newData.filter((row, idx) => idx !== index));
    onDeleteRowCallback(
      newData.filter((row, idx) => idx !== index),
      index
    );
  };

  useEffect(() => setNewData(data), [data]);

  return (
    <Row
      className="justify-content-end"
      style={{
        width:
          linkBtn?.length > 0
            ? `${linkBtn?.length * 40 + 70}px`
            : activeButton?.length > 0
            ? `${activeButton?.length * 40 + 70}px`
            : "150px"
      }}
    >
      <Col className={`p-0 ${show ? "w-auto visible" : "invisible"}`}>
        {linkBtn
          ? linkBtn.map(({ state, button, icon }) => (
              <ButtonLink
                key={`linkBtn-${rowIndex}`}
                linkTo={"sub"}
                stateData={{ ...state, data, row: data?.[rowIndex] }}
                buttonColor={button?.color}
                buttonClass={button?.className}
                iconSrc={icon?.src}
                iconName={icon?.alt}
              />
            ))
          : activeButton.map((btn, idx) => (
              <Button
                key={`${btn}-${idx}`}
                variant={btn === "delete" ? "outline-danger":"outline-secondary"}  
                className="w-auto h-100 p-2 bg-transparent border-0"
                disabled={btn === "delete" && newData.length === 1}
                onClick={() => {
                  if (btn === "upload") fileInputRef.current.click();
                  else if (btn === "add") handleAddRow(rowIndex);
                  else if (btn === "copy") handleCopyRow(rowIndex);
                  else if (btn === "delete") handleDeleteRow(rowIndex);
                  else if (btn === "view")  navigate(navView.path, {state: navView.state })
                }}
              >
                <Image
                  src={
                    btn === "upload"
                      ? UploadCloudIcon
                      : btn === "add"
                      ? ListPlusIcon
                      : btn === "copy"
                      ? ListCheckIcon
                      : btn === "view"
                      ? PreviewIcon
                      : DeleteIcon
                  }
                  alt={`${btn} Icon`}
                />
                {btn === "upload" && (
                  <Form.Control
                    ref={fileInputRef}
                    type="file"
                    className="d-none"
                    accept=".pdf"
                    onChange={({ target }) => {
                      handleUploadFile(target.files[0]);
                      target.value = null;
                    }}
                  />
                )}
              </Button>
            ))}
      </Col>

      <Button
        variant="outline-secondary"
        className="w-auto mb-1 p-2 bg-transparent border-0"
        onClick={() => setShow(!show)}
      >
        <Image src={OverflowMenuIcon} alt="Overflow Menu Icon" />
      </Button>
    </Row>
  );
};

ButtonOptionGroup.propTypes = {
  rowIndex: PropTypes.number.isRequired,
  data: PropTypes.array.isRequired,
  defaultData: PropTypes.object.isRequired,
  linkBtn: PropTypes.array,
  activeButton: PropTypes.array,
  onUploadCallback: PropTypes.func,
  onAddRowCallback: PropTypes.func,
  onCopiedRowCallback: PropTypes.func,
  onDeleteRowCallback: PropTypes.func,
  navView: PropTypes.object
};

export default ButtonOptionGroup;
